import { apiClient } from "../config";

async function updateColumnMapping(id: any, data: any) {
  const url = `/admin/imports/${id}/column-mapping`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default updateColumnMapping;
